module.exports = __webpack_public_path__ + "img/blank-message.8ca855d1.svg";